import { createContext } from 'react';
import { MOBILE_NAVIGATION_MIN_HEIGHT } from './MobileNavigation';

export const MobileFooterGeometry = createContext({
  navigationHeight: MOBILE_NAVIGATION_MIN_HEIGHT,
  setNavigationHeight: (_height: number) => {},
});
